(function () {
  'use strict';
  document.documentElement.classList.add('cf-js');

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Segmented control for silk / fresh plans (WAI-ARIA tabs pattern)
  function initTabs() {
    document.querySelectorAll('[data-cf-tabs]').forEach(function (list) {
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') next = tabs[0];
          if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) { e.preventDefault(); select(next, true); }
        });
      });
      if (location.hash === '#fresh') {
        var fresh = document.getElementById('cf-tab-fresh');
        if (fresh) select(fresh, false);
      }
    });
  }

  // Product page plan picker
  function initProductForm() {
    var form = document.querySelector('[data-cf-product-form]');
    if (!form) return;
    var idInput = form.querySelector('[data-cf-variant-id]');
    var priceEl = form.querySelector('[data-cf-price]');
    var nameEl = form.querySelector('[data-cf-plan-name]');
    form.querySelectorAll('input[name="cf-plan"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        idInput.value = radio.value;
        if (priceEl) priceEl.textContent = radio.dataset.price;
        if (nameEl) nameEl.textContent = radio.dataset.title;
        var url = new URL(location.href);
        url.searchParams.set('variant', radio.value);
        history.replaceState(null, '', url.toString());
      });
    });
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[data-cf-submit]');
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '0.7'; }
    });
  }

  // Product gallery thumbnails
  function initGallery() {
    var gallery = document.querySelector('[data-cf-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('.cf-product__main-media img');
    gallery.querySelectorAll('.cf-product__thumbs button').forEach(function (btn, _, all) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = btn.dataset.src;
        main.srcset = btn.dataset.srcset;
        main.alt = btn.dataset.alt || '';
        Array.prototype.forEach.call(all, function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
      });
    });
  }

  // Mobile sticky action bar: visible after the hero, hidden while plans are on screen
  function initStickyBar() {
    var bar = document.querySelector('[data-cf-stickybar]');
    var hero = document.querySelector('[data-cf-hero]');
    var plans = document.querySelector('[data-cf-plans]');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    var heroVisible = true;
    var plansVisible = false;
    function update() {
      var show = !heroVisible && !plansVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var link = bar.querySelector('a');
      if (link) link.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (entries) {
      heroVisible = entries[0].isIntersecting; update();
    }).observe(hero);
    if (plans) {
      new IntersectionObserver(function (entries) {
        plansVisible = entries[0].isIntersecting; update();
      }, { threshold: 0.15 }).observe(plans);
    }
  }

  // Bring a submitted contact form back into view
  function initFormFocus() {
    var status = document.querySelector('.cf-form__status');
    if (status) status.scrollIntoView({ block: 'center' });
  }

  // Scroll animations: sections ease in as they reach the viewport.
  // Skipped entirely for reduced motion or browsers without IntersectionObserver.
  function initReveal() {
    var items = document.querySelectorAll('[data-cf-reveal]');
    if (!items.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;

    document.documentElement.classList.add('cf-animate');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    items.forEach(function (el) {
      var delay = el.getAttribute('data-cf-delay');
      if (delay) el.style.setProperty('--cf-delay', delay + 'ms');
      observer.observe(el);
    });

    // Safety net: never leave content hidden if an observer callback is missed.
    window.setTimeout(function () {
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('is-revealed');
      });
    }, 1500);
  }

  onReady(function () {
    initReveal();
    initTabs();
    initProductForm();
    initGallery();
    initStickyBar();
    initFormFocus();
  });
})();
